exports.onRouteUpdate = ({ location }) => {
  analytics.pageview(location.pathname)
}
